import { render, staticRenderFns } from "./TheWizardWindow.vue?vue&type=template&id=872651b4"
import script from "./TheWizardWindow.vue?vue&type=script&lang=js"
export * from "./TheWizardWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports